import React from 'react'
import PropTypes from 'prop-types'
import { startCase } from 'lodash'
import Styles from './index.scss'

const CountryFilter = props => (
  <select
    name="country"
    onChange={props.setCountryFilter(props.user.filter.email)}
    className={Styles['country-dropdown']}
  >
    <option value="">Country</option>
    {props.selectionsCountry.map((country, index) => (
      <option key={`country_${index + 1}`} value={country.value}>
        {startCase(country.label)}
      </option>
    ))}
  </select>
)

CountryFilter.propTypes = {
  setCountryFilter: PropTypes.func.isRequired,
  user: PropTypes.shape({
    filter: PropTypes.shape({
      email: PropTypes.string,
    }).isRequired,
  }).isRequired,
  selectionsCountry: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default CountryFilter
